import { useState } from 'react';

import { IS_CERTIFICATION_RELEASE_DISMISSED } from 'src/features/dashboard/dashboard.constants';
import { HookOutput } from 'src/common/components/community-section';

export const useShowCertificationRelease = (): HookOutput => {
  const [isClosed, setIsClosed] = useState(() => {
    const storedValue = localStorage.getItem(IS_CERTIFICATION_RELEASE_DISMISSED);
    return storedValue === 'true';
  });

  const isShowCertificationRelease = !isClosed;

  const hideCertificationRelease = () => {
    setIsClosed(true);
    localStorage.setItem(IS_CERTIFICATION_RELEASE_DISMISSED, 'true');
  };

  return [isShowCertificationRelease, hideCertificationRelease];
};
